import { render } from "./breadcrumb.vue?vue&type=template&id=2b82cf82&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=2b82cf82&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/www.usevia.cn/fileManage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b82cf82"]])

export default __exports__